import { TimelineEntryTypeContext } from '../../context/TimelineEntryTypeProvider';
import { useNotNullableContext } from '../useNotNullableContext';

// B2C_048 - show hide fitness data
// EntryType can be removed when experiment has ended
// or added as a non experiment test if successful
export const useTimelineEntryType = () =>
  useNotNullableContext(TimelineEntryTypeContext);
